<template>
    <div class="container">
    <div style="background-color: white; padding: 20px;">
      <h2 style="color: black;">🐾 Your Purr-fect Guide to Insurance Premiums 🐾</h2>
      <div style="background-color: white; padding: 20px; border-radius: 10px;">
        <img :src="require('@/assets/cat-notimpressed.gif')" alt="Cat Not impressed" width="250" height="250" />
        <p style="color: black;">Ah, insurance—a necessary evil, like taking your cat to the vet. 😾👩‍⚕️ You might wonder why it feels like insurance companies are playing a game of yarn with your wallet. But there's a method to the madness, and it's grounded in data, probability, and—wait for it—math! 📚🔢

Insurance companies calculate your premium by assessing various risk factors like your age, location, and even your claims history. All this number-crunching allows them to predict how likely you are to make a claim. So, the more 'risky' you are, the higher your premiums. It's not personal, just purr-obability. 🐱‍🏍📉

<br>Now, let's dive into what you've all been waiting for—the numbers that make your tail twitch! 🐾💰
        
        
        
        </p>  
        <h3>Home Sweet Home Insurance 🏠</h3>
          
          <ul>
            <li>Basic Coverage: $300 - $1,000 annually - Covers you for the simple stuff, like fires and cat burglaries. 🚒🐾</li>
            <li>Enhanced Purr-tection: $1,000 - $2,000 annually - Greater coverage for more complex catastrophes. 🛡️🎩</li>
            <li>The Cat's Meow: $2,000 - $5,000 annually - Ultimate protection, like a cat on the prowl guarding its territory. 🌟🐱</li>
          </ul>
        
  
        <h3>Automobile Insurance 🚗</h3>
          <ul>
            <li>Basic Paws: $500 - $1,000 annually - Just the minimal stuff—paws and seatbelts! 🐾</li>
            <li>Comfort Purr: $1,000 - $2,000 annually - Adds more layers of comfort, like collision coverage. 🛡️🚗</li>
            <li>Feline Luxe: $1,500 - $3,000 annually - All the bells and whiskers for your furr-ari! 🌟🚗</li>
          </ul>
    
          <h3>Travel Insurance</h3>
          <ul>
            <li>You can get a policy based on trip or annually that covers you up to a specific number of days out of the country🐾</li>
            <li>You may already have this through your employer so it's always good to check</li>
            <li>Check your destination for government guidance as not all insurance coverages apply in volatile places.  Sadly there's places in this world that aren't as comfy as my cat bed so know your coverage before you go. </li>
          </ul>
  
          <h3>Claw-some Money-Saving Tips 🐱💰</h3>
          
Raise Those Deductibles! Look up group discounts! Sharing is caring when it comes to your policy. 
<ul>
<li>A bigger deductible can likely save you money over the long-term if you are not accident prone.  For my fellow orange cats who are always getting into mischief you may want to keep it low! 📉</li>


<li>Group Purr-chasing Power 🎓 -Part of an alumni or a cat lovers group? Score a 5-10% discount! Most University/College Alumni have a plan and so do a lot of professional membership organizations.  It pays to do some research.</li>
<li>Eco-Kitty Cars 🌍 - Own a hybrid or electric car? Purr-fect, save up to 10% on premiums!</li>
<li>Anti-Theft Whiskers 🛡️ - Fortify your home or car like a cat fort, and save up to 20%. 🐾</li>
<li>Multi-Vehicle & Multi-Home Discounts 🚗🏠 - Insure multiple cars or bundle your car and home insurance for even more savings! 🐱‍🚀</li>
</ul>
<b>Why Be Insured?</b> 🌟<br>

Financial Cat-nap: Secure your nest egg with the right coverage. 🛡️<br>

Furr-sightful Savings: Pay a small premium now to avoid big vet bills later. 💰<br>

Do You Know?: Does your auto insurance cover your friend driving or that rental car? Curiosity doesn't have to kill the cat! 🚗 <br>

<br>Remember, smart cats are covered cats. Future you will purr in delight! 🐱💕   

<p>
  Don’t let your insurance renewal dates sneak up on you! With RiskyPaws, simply enter your policy details, including the renewal date, and we'll make sure you're reminded in advance. <br><br>📆✨ Keep track of your insurance policies effortlessly and make informed decisions when it’s time to renew. No more last-minute scrambles - just peace of mind knowing that RiskyPaws has your back! 
</p>
    
    </div></div>
</div> <br><br><br><br><br><br>
  </template>

<style scoped>
.container {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
  color: black;
  padding: 20px;
  border-radius: 20px;
}


.content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: black;
}
</style>
  